import $ from 'jquery';
import 'readmore-js';

$(document).ready(function () {
  var more;
  var less;
  more = 'Bekijk meer distributeurs';
  less = 'Bekijk minder distributeurs';
  if($('.check-current-lang-en').length){
    more = 'View more distributors';
    less = 'View fewer distributors';
  }

  if (screen.width < 767) {
    $('.dealers__readmore').readmore({
      embedCSS: true,
      moreLink: '<a href="#" class="btn btn--primary mt-3 d-inline-block">'+more+'</a>',
      lessLink: '<a href="#" class="btn btn--primary mt-3 d-inline-block">'+less+'</a>',
      collapsedHeight: 525,
    });
  } else {
    $('.dealers__readmore').readmore({
      embedCSS: true,
      moreLink: '<a href="#" class="btn btn--primary mt-3 d-inline-block">'+more+'</a>',
      lessLink: '<a href="#" class="btn btn--primary mt-3 d-inline-block">'+less+'</a>',
      collapsedHeight: 513,
    });
  }
});

